import Axios from "axios";

export default {
    loadDashboards: (context) => {
        Axios({
            url: '/api/v1/dashboards',
            method: 'GET',
        }).then(resp => {
            context.commit('dashboardsLoadSuccess', resp.data);
        }).catch((err) => {
            context.commit('dashboardsLoadFailure', err);
        });
    },
    loadUserDashboards: (context) => {
        Axios({
            url: '/api/v1/user_dashboards',
            method: 'GET',
        }).then(resp => {
            context.commit('userDashboardsLoadSuccess', resp.data);
        }).catch((err) => {
            context.commit('userDashboardsLoadFailure', err);
        });
    },
    loadGameTypes: (context) => {
        Axios({
            url: '/api/v1/game_types',
            method: 'GET',
        }).then(resp => {
            context.commit('gameTypesLoadSuccess', resp.data);
        }).catch((err) => {
            context.commit('gameTypesLoadFailure', err);
        });
    },
    loadUserGameTypes: (context) => {
        Axios({
            url: '/api/v1/user_game_types',
            method: 'GET',
        }).then(resp => {
            context.commit('userGameTypesLoadSuccess', resp.data);
        }).catch((err) => {
            context.commit('userGameTypesLoadFailure', err);
        });
    },
};
